import * as React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ListSubheader from '@material-ui/core/ListSubheader';
import * as releaseAdmin from '../../../../../sdk/release-admin';
import { BackofficeUser } from '../../../../../../../../services/release-admin/types/backoffice-user';


interface TransferDialogProps {
  isOpen: boolean
  title: string;
  onClose: () => void;
  onSend: (userId: string) => void;
}

export const TransferDialog: React.FC<TransferDialogProps> = (props) => {

  const [userId, setUserId] = React.useState('');
  const [users, setUsers] = React.useState<BackofficeUser[]>([]);

  React.useEffect(() => {
    releaseAdmin.listUsers()
      .then(async (response) => {
        setUsers(response.results.filter((u) => !!u.name))
      })
  }, []);

  return (
    <Dialog open={props.isOpen} onClose={props.onClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel id="user-list-label">Select User/Group</InputLabel>
          <Select
            labelId="user-list-label"
            id="user-list-select"
            value={userId}
            label="Select User/Group"
            onChange={(ev) => setUserId(ev.target.value as string)}
          >
            <ListSubheader>Groups</ListSubheader>
            <MenuItem value={'tier-1'}>Tier 1</MenuItem>
            <MenuItem value={'tier-2'}>Tier 2</MenuItem>
            <MenuItem value={'tier-3'}>Tier 3</MenuItem>
            <ListSubheader>Users</ListSubheader>
            {users.map((user) => (
              <MenuItem key={user.pk} value={user.pk}>{`${user.name} (${user.tier})`}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary">
          Cancel
        </Button>
        <Button disabled={!userId} onClick={() => props.onSend(userId)} color="default">
          Transfer
        </Button>
      </DialogActions>
    </Dialog>
  )
}